import React, { useState, useEffect, useRef } from "react";

// -------------------- UTILITY FUNCTIONS --------------------

// Parse timestamp to { year, month, day } without using new Date
export const parseTimestamp = (timestamp) => {
  const msPerDay = 24 * 60 * 60 * 1000;
  const daysSinceEpoch = Math.floor(timestamp / msPerDay);

  let year = 1970;
  let dayCount = daysSinceEpoch;
  const isLeap = (y) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;

  while (true) {
    const daysInYear = isLeap(year) ? 366 : 365;
    if (dayCount >= daysInYear) {
      dayCount -= daysInYear;
      year++;
    } else break;
  }

  const monthDays = [
    31,
    isLeap(year) ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  let month = 0;
  while (dayCount >= monthDays[month]) {
    dayCount -= monthDays[month];
    month++;
  }

  const day = dayCount + 1;
  return { year, month: month + 1, day };
};

// Format timestamp to yyyy-mm-dd
export const formatDisplayDate = (timestamp) => {
  if (!timestamp) return "";
  const d = parseTimestamp(timestamp);
  return `${d.year}-${String(d.month).padStart(2, "0")}-${String(
    d.day
  ).padStart(2, "0")}`;
};

// Add/subtract days in timestamp
export const addDays = (timestamp, days) =>
  timestamp + days * 24 * 60 * 60 * 1000;

// Days in month
export const daysInMonth = (year, month) => {
  const md = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (month === 2 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0))
    return 29;
  return md[month - 1];
};

// -------------------- MAIN COMPONENT --------------------
const CommonHistorydate = ({ fetchServerTime, onChange }) => {
  const dropdowndateRef = useRef(null);
  const [hoverDate, setHoverDate] = useState(null);
  const [serverTime, setServerTime] = useState(null);
  const [selecteddateOption, setSelecteddateOption] = useState(
    "realTradingDefault4"
  ); // Default Last 30 Days
  const [filterdates, setFilterdates] = useState({
    start_date: null,
    end_date: null,
  });
  const [startMonthOffset, setStartMonthOffset] = useState(1);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
  const parseTimestamp = (timestamp) => {
    const msPerDay = 24 * 60 * 60 * 1000;
    const daysSinceEpoch = Math.floor(timestamp / msPerDay);

    let year = 1970;
    let dayCount = daysSinceEpoch;
    const isLeap = (y) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;

    while (true) {
      const daysInYear = isLeap(year) ? 366 : 365;
      if (dayCount >= daysInYear) {
        dayCount -= daysInYear;
        year++;
      } else break;
    }

    const monthDays = [
      31,
      isLeap(year) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ];
    let month = 0;
    while (dayCount >= monthDays[month]) {
      dayCount -= monthDays[month];
      month++;
    }

    const day = dayCount + 1;
    return { year, month: month, day };
  };
  // ---------------- FETCH SERVER TIME ON MOUNT ----------------
  useEffect(() => {
    const initServerTime = async () => {
      const data = await fetchServerTime();
      if (data?.success) {
        const ts = data.adjustedTimestamp; // already adjusted
        setServerTime(ts);
        // Default Last 30 Days
        const start = addDays(ts, -29);
        const end = ts;
        setFilterdates({ start_date: start, end_date: end });

        if (onChange) onChange(start, end);
      }
    };
    initServerTime();
  }, []);

  // ---------------- HANDLE RADIO CHANGE ----------------
  const handleRadioChange = (id, closeDropdown = false) => {
    if (!serverTime) return;
    setSelecteddateOption(id);

    // if (closeDropdown) setIsDropdownOpen2(false);
    if (id !== "realTradingDefault8") setIsDropdownOpen2(false);
    let start = null,
      end = serverTime;

    switch (id) {
      case "realTradingDefault1": // Today
        start = end = serverTime;
        break;
      case "realTradingDefault2": // Yesterday
        start = end = addDays(serverTime, -1);
        break;
      case "realTradingDefault3": // Last 7 Days
        start = addDays(serverTime, -6);
        break;
      case "realTradingDefault4": // Last 30 Days
        start = addDays(serverTime, -29);
        break;
      case "realTradingDefault5": {
        // Current Month
        const d = parseTimestamp(serverTime);
        start = serverTime - (d.day - 1) * 24 * 60 * 60 * 1000;
        break;
      }
      case "realTradingDefault6": {
        // Previous Month
        const d = parseTimestamp(serverTime);
        let prevMonth = d.month === 1 ? 12 : d.month - 1;
        let year = d.month === 1 ? d.year - 1 : d.year;
        start =
          serverTime -
          d.day * 24 * 60 * 60 * 1000 -
          (daysInMonth(year, prevMonth) - 1) * 24 * 60 * 60 * 1000;
        end = serverTime - d.day * 24 * 60 * 60 * 1000;
        break;
      }
      case "realTradingDefault7": // All Time
        start = null;
        break;
      case "realTradingDefault8": // Custom
        return;
      default:
        return;
    }

    setFilterdates({ start_date: start, end_date: end });
    if (onChange) onChange(start, end);
  };

  // ---------------- HANDLE CALENDAR NAV ----------------
  const handlePrev = () => setStartMonthOffset((prev) => prev - 1);
  const handleNext = () => setStartMonthOffset((prev) => prev + 1);

  // ---------------- RENDER CALENDAR ----------------
  // const getMonthDays = (year, month) => {
  //   const firstDay = new Date(year, month, 1).getDay();
  //   const totalDays = new Date(year, month + 1, 0).getDate();
  //   const days = [];

  //   for (let i = 0; i < (firstDay === 0 ? 6 : firstDay - 1); i++) days.push(null);
  //   for (let d = 1; d <= totalDays; d++) {
  //     days.push(new Date(year, month, d));
  //   }
  //   return days;
  // };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };

  const getTimestamp = (year, month, day) => {
    const msPerDay = 24 * 60 * 60 * 1000;
    let days = 0;
    for (let y = 1970; y < year; y++) {
      days += y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0) ? 366 : 365;
    }

    const monthDays = [
      31,
      year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ];
    for (let m = 0; m < month; m++) days += monthDays[m];
    days += day - 1;
    return days * msPerDay;
  };
  const getMonthDays = (year, month) => {
    const monthDays = [
      31,
      year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ];
    const totalDays = monthDays[month];

    const firstDayTs = getTimestamp(year, month, 1);
    const { weekday: firstWeekday } = parseTimestamp(firstDayTs);
    const days = [];

    // Adjust to Monday-based calendar (Mon=0, Sun=6)
    const offset = (firstWeekday + 6) % 7;
    for (let i = 0; i < offset; i++) days.push(null);

    for (let d = 1; d <= totalDays; d++) {
      days.push({ year, month, day: d });
    }
    return days;
  };
  const handleDateClick = (timestamp) => {
    const oneDay = 24 * 60 * 60 * 1000;

    // Helpers
    const startOfDay = (ts) => ts - (ts % oneDay); // 00:00:00
    const endOfDay = (ts) => startOfDay(ts) + oneDay - 1000; // 23:59:59

    if (
      !filterdates.start_date ||
      (filterdates.start_date && filterdates.end_date)
    ) {
      // First click → set start
      const start = startOfDay(timestamp);
      setFilterdates({ start_date: start, end_date: null });
      // setStartDate(start);
      // setEndDate(null);
      if (onChange) onChange(start, null);
    } else if (timestamp >= filterdates.start_date) {
      // Second click → set end
      const end = endOfDay(timestamp);
      setFilterdates({ start_date: filterdates.start_date, end_date: end });
      if (onChange) onChange(filterdates.start_date, end);
    } else {
      // Clicked before current start → reset start
      const start = startOfDay(timestamp);
      setFilterdates({ start_date: start, end_date: null });
      if (onChange) onChange(start, null);
    }
  };
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const isRangeDate = (year, month, day) => {
    if (!filterdates.start_date || !filterdates.end_date) return false;

    const ts = getTimestamp(year, month, day);

    const s = filterdates.start_date;
    const e = filterdates.end_date;

    return ts > s && ts < e;
  };
 const isHoverRange = (year, month, day) => {
  if (!filterdates.start_date) return false;
  if (filterdates.end_date) return false; 
  if (!hoverDate) return false;
  const ts = getTimestamp(year, month, day);
  const start = filterdates.start_date;
  const hoverTS = hoverDate;
  if (hoverTS > start) {
    return ts > start && ts < hoverTS;
  }
  return false;
};
  const renderCalendar = (year, month, isCustom = false) => {
    const days = getMonthDays(year, month);
    const monthName = monthNames[month];
    return (
      <div key={`${year}-${month}`} className="calendar-month">
        <div className="calendar-header">
          {monthName} {year}
        </div>
        <div className="calendar-grid">
          {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((d) => (
            <div key={d} className="calendar-day-label">
              {d}
            </div>
          ))}

          {days.map((date, idx) => {
            const ts = getTimestamp(date.year, date.month, date.day);
            const startTs = filterdates.start_date
              ? Number(filterdates.start_date)
              : null;
            const endTs = filterdates.end_date
              ? Number(filterdates.end_date)
              : null;
            const oneDay = 24 * 60 * 60 * 1000;
            const normalize = (t) => Math.floor(t / oneDay) * oneDay;

            const isSelected =
              (startTs && normalize(ts) === normalize(startTs)) ||
              (endTs && normalize(ts) === normalize(endTs));

            return (
              <div
                key={idx}
                className={`calendar-cell ${
                  isSelected
                    ? "selected"
                    : isRangeDate(date.year, date.month, date.day)
                    ? "daterange"
                    : isHoverRange(date.year, date.month, date.day)
                    ? "daterange"
                    : ""
                }`}
                onClick={() => handleDateClick && handleDateClick(ts)}
                onMouseEnter={() => setHoverDate(ts)}
                onMouseLeave={() => setHoverDate(null)}
              >
                {date.day}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

 const getAdjustedYearMonth = (year, month) => {
   let y = year;
   let m = month;
 
   while (m < 0) {
     m += 12;
     y -= 1;
   }
 
   while (m > 11) {
     m -= 12;
     y += 1;
   }
 
   return { year: y, month: m };
 };
 
 const getVisibleMonths = () => {
   if (!serverTime) return [];
 
   const d = parseTimestamp(serverTime);
 
   const currentMonth = d.month - 1;
 
   const first = getAdjustedYearMonth(
     d.year,
     currentMonth + startMonthOffset - 1
   );
 
   const second = getAdjustedYearMonth(
     d.year,
     currentMonth + startMonthOffset
   );
 
   return [first, second];
 };

  // ---------------- CLOSE DROPDOWN OUTSIDE ----------------
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdowndateRef.current &&
        !dropdowndateRef.current.contains(event.target)
      ) {
        setIsDropdownOpen2(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ---------------- RENDER ----------------
  return (
    <div
      className="dropdown realTrading_dt mw-100 tradeSummary01 mb-0"
      ref={dropdowndateRef}
    >
      <label>Select Date</label>
      <button
        className="btn dropdown-toggle"
        type="button"
        style={{ border: "1px solid #474451" }}
        aria-expanded={isDropdownOpen2}
        onClick={() => setIsDropdownOpen2(!isDropdownOpen2)}
      >
        <span>
          <i className="fa-solid fa-calendar-days"></i>{" "}
          {selecteddateOption === "realTradingDefault7"
            ? "All time"
            : filterdates.start_date && filterdates.end_date
            ? `${formatDisplayDate(
                filterdates.start_date
              )} - ${formatDisplayDate(filterdates.end_date)}`
            : ""}
        </span>
        <i className="fa-solid fa-angle-down ms-2"></i>
      </button>

      <div
        className={`${
          isDropdownOpen2 ? "dropdown-menu show" : "dropdown-menu"
        }`}
      >
        <ul>
          {[
            { id: "realTradingDefault1", label: "Today" },
            { id: "realTradingDefault2", label: "Yesterday" },
            { id: "realTradingDefault3", label: "Last 7 days" },
            { id: "realTradingDefault4", label: "Last 30 days" },
            { id: "realTradingDefault5", label: "Current month" },
            { id: "realTradingDefault6", label: "Previous month" },
            { id: "realTradingDefault7", label: "All time" },
          ].map((item) => (
            <li key={item.id}>
              <div
                className={`form-check ${
                  selecteddateOption === item.id ? "active" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id={`${item.id}date`}
                  checked={selecteddateOption === item.id}
                  onChange={() => handleRadioChange(item.id, false)}
                  onClick={() => setIsDropdownOpen2(!isDropdownOpen2)}
                />
                <label className="form-check-label" htmlFor={`${item.id}date`}>
                  {item.label}
                </label>
              </div>
            </li>
          ))}

          <li>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="realTradingDefault8date"
                checked={selecteddateOption === "realTradingDefault8"}
                onChange={() => handleRadioChange("realTradingDefault8", true)}
              />
              <label
                className="form-check-label"
                htmlFor="realTradingDefault8date"
              >
                Custom range
              </label>
            </div>
          </li>
        </ul>

        {selecteddateOption === "realTradingDefault8" && (
          <div className="range-right">
            <div className="date-inputs">
              <input
                type="text"
                readOnly
                value={
                  filterdates.start_date
                    ? formatDisplayDate(filterdates.start_date)
                    : ""
                }
              />
              <input
                type="text"
                readOnly
                value={
                  filterdates.end_date
                    ? formatDisplayDate(filterdates.end_date)
                    : ""
                }
              />
            </div>
            <div className="calendar-bg0">
              <div className="calendar-wrapper">
                <button
                  onClick={(e) => {
                    handlePrev();
                    e.preventDefault();
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  onClick={(e) => {
                    handleNext();
                    e.preventDefault();
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
              {getVisibleMonths().map(({ year, month }) =>
                renderCalendar(year, month, true)
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonHistorydate;
